import React from 'react';
import { Box, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, Chip, Stack } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import usePortfolioStore from '../store/portfolioStore.js';

export default function Skills() {
  const { skillsCatalog } = usePortfolioStore();
  return (
    <Box>
      <Typography variant="h5" gutterBottom>Skills</Typography>
      <Grid container spacing={2}>
        {skillsCatalog.map((cat) => (
          <Grid key={cat.category} item xs={12} md={6}>
            <Accordion defaultExpanded className="glass">
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">{cat.category}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                  {cat.items.map((s) => <Chip key={s} label={s} />)}
                </Stack>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}


